import { Route, Routes, Outlet } from 'react-router-dom'
import { PageLink, PageTitle } from '../../../../_metronic/layout/core'
import { AtendimentosListWrapper } from './atendimento-list/AtendimentoList'
import { TeleAtendimento } from '../atendimento_medicos/atendimento-video/tele-atendimento'

const atendimentoBreadcrumbs: Array<PageLink> = [
  {
    title: '',
    path: '/apps/atendimentos/paciente',
    isSeparator: true,
    isActive: true,
  },
  {
    title: '',
    path: '/apps/atendimentos/teleAtendimento',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const AtendimentosPage = () => {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path='paciente'
          element={
            <>
              <PageTitle>Meus atendimentos</PageTitle>
              <AtendimentosListWrapper />
            </>
          }
        />
        <Route
          path='teleAtendimento'
          element={
            <>
              <PageTitle breadcrumbs={atendimentoBreadcrumbs}>Tele Atendimento</PageTitle>
              <TeleAtendimento rotaLista='/apps/atendimentos/paciente' />
            </>
          }
        />
      </Route>
      {/* <Route index element={<Navigate to='/apps/atendimentos/paciente' />} /> */}
    </Routes>
  )
}

export default AtendimentosPage
